D.addEventListener("DOMContentLoaded", function() {

//fr parallax slider
	let	interleaveOffsetGallery = 0.2;

	const frSwiper = new Swiper('.js-fr-slider', {
		slidesPerView: 1,
		spaceBetween: 40,
		loop: false,
		speed: 1800,
		simulateTouch: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: '.js-fr-slider__next',
			prevEl: '.js-fr-slider__prev',
		},
		breakpoints: {
			576: {
				spaceBetween: 10
			},
			992: {
				spaceBetween: 25
			},
		},
		on: {
			progress: function(){
			  let swiper = this;
			  for (let i = 0; i < swiper.slides.length; i++) {
				let slideProgress = swiper.slides[i].progress,
					innerOffset = swiper.width * interleaveOffsetGallery,
					innerTranslate = slideProgress * innerOffset;
					swiper.slides[i].querySelector(".js-fr-slide").style.transform = "translate3d(" + innerTranslate + "px, 0, 0)";
			  }
			},
			touchStart: function() {
			  let swiper = this;
			  for (let i = 0; i < swiper.slides.length; i++) {
				swiper.slides[i].style.transition = "";
			  }
			},
			setTransition: function(speed) {
			  let swiper = this;
			  for (let i = 0; i < swiper.slides.length; i++) {
				swiper.slides[i].style.transition = speed + "ms";
				swiper.slides[i].querySelector(".js-fr-slide").style.transition =
				  speed + "ms";
			  }
			}
		  }
	});

});